var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cart-template",
    {
      key: _vm.earlyRenewal,
      class: { "overlay prelative": _vm.activeCompare },
      attrs: { isSales: true, customer: _vm.customer }
    },
    [
      _c(
        "template",
        { slot: "configuration" },
        [
          _c("p", { staticClass: "cart-config-title mb-0" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$l10n.__("Abonnement de")) +
                " " +
                _vm._s(_vm.customer.name) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-1 mb-6 semibold gray-60 fs-3" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$l10n.__("Date d'activation de l'abonnement")))
            ]),
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm._f("dateFormatter")(
                    _vm.periodApplianceStart,
                    "SLASHED_DATE",
                    false
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.legacyProducts.length > 0
            ? _c(
                "card",
                {
                  staticClass: "br mb-4 fs-3 legacy-products",
                  attrs: {
                    background: "alert-05",
                    borderColor: "alert-50",
                    padding: 2
                  }
                },
                [
                  _c("div", { staticClass: "pl-2 pr-2" }, [
                    _c("p", { staticClass: "bold mt-0 mb-1" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Des anciens modules sont actifs sur ce compte :"
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "mb-0 mt-0 pl-4 module-list" },
                      _vm._l(_vm.legacyProducts, function(legacyProduct) {
                        return _c("li", { key: legacyProduct.code }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(legacyProduct.name) +
                              "\n                    "
                          )
                        ])
                      }),
                      0
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("subscription-summary", {
            attrs: { context: "renew", isSales: "" }
          }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "saleCartForm",
              staticClass: "mt-6",
              attrs: {
                "label-position": "top",
                rules: _vm.setRules,
                model: _vm.modelForm
              }
            },
            [
              _c("date-config", { attrs: { store: "renew" } }),
              _vm._v(" "),
              _c("h1", [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__("Configuration de l’offre de renouvellement")
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "article",
                [
                  _c(
                    "header",
                    { staticClass: "flex-level ai-center mt-6 mb-4" },
                    [
                      _c("h2", { staticClass: "m-0" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Le plan")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "ml-3 link",
                          attrs: {
                            href: "https://go.sellsy.com/tarifs/",
                            target: "_blank"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$l10n.__("Comparer les plans")))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.licencePlan,
                            callback: function($$v) {
                              _vm.licencePlan = $$v
                            },
                            expression: "licencePlan"
                          }
                        },
                        _vm._l(_vm.plans, function(plan) {
                          return _c(
                            "el-radio",
                            {
                              key: plan.code,
                              attrs: {
                                disabled: plan.disabled,
                                label: plan.code
                              }
                            },
                            [
                              _c(
                                "tag-label",
                                {
                                  staticClass: "semibold uppercase",
                                  attrs: {
                                    bgColor: plan.color,
                                    disabled: plan.disabled
                                  }
                                },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(_vm._s(plan.name))
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "separator block my-6" }),
              _vm._v(" "),
              _c(
                "article",
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "flex-column-content",
                      attrs: { prop: "products" },
                      scopedSlots: _vm._u([
                        {
                          key: "error",
                          fn: function(ref) {
                            var error = ref.error
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "absolute wp-10 mt-0 mb-5 alert alert-danger",
                                  staticStyle: { order: "-1" }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(error) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c(
                        "header",
                        { staticClass: "flex-row jc-space ai-center mb-5" },
                        [
                          _c("h2", { staticClass: "m-0" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Les licences")))
                          ]),
                          _vm._v(" "),
                          _c("radio-input", {
                            attrs: {
                              mode: "edit",
                              "radio-style": "button",
                              value: _vm.recurrency,
                              choices: _vm.recurrencies
                            },
                            on: { change: _vm.updateRecurrency }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.availablesProducts, function(product) {
                        return _c("licence-product", {
                          key: product.code,
                          staticClass: "mb-5",
                          attrs: {
                            value: _vm.products[product.id],
                            product: product,
                            plan: _vm.plan,
                            userType: "sale",
                            numformat: _vm.numformat,
                            saleLimitation: _vm.renewOnOlderPricingVersion
                          },
                          on: { input: _vm.updateProductQuantity }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "separator block my-6" }),
              _vm._v(" "),
              _c(
                "article",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("header", [
                        _c("h2", { staticClass: "mb-5" }, [
                          _vm._v(
                            _vm._s(_vm.$l10n.__("Modules supplémentaires"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.availablesPacks.concat(_vm.currentGroupedPacks),
                        function(product) {
                          return _c("bonus-pack", {
                            key: product.code,
                            staticClass: "mb-5",
                            attrs: {
                              value: _vm.products[product.id],
                              product: product,
                              plan: _vm.plan,
                              numformat: _vm.numformat,
                              userType: "sale",
                              sourceLimitation: false
                            },
                            on: {
                              input: _vm.updateProductQuantity,
                              changePackPlan: _vm.switchPackPlan
                            }
                          })
                        }
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "separator block my-6" }),
              _vm._v(" "),
              _vm.renewOnOlderPricingVersion
                ? _c("staffs", { staticClass: "mb-6" })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "article",
                [
                  _c("header", [
                    _c("h2", { staticClass: "mt-0 mb-5" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Paiement")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t.__("common.labels.payment_method")
                      }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { prop: "paymentMethod" },
                          model: {
                            value: _vm.payment,
                            callback: function($$v) {
                              _vm.payment = $$v
                            },
                            expression: "payment"
                          }
                        },
                        _vm._l(_vm.paymentMethods, function(payment) {
                          return _c(
                            "el-radio",
                            {
                              key: payment.id,
                              staticClass: "black",
                              attrs: {
                                label: payment.id,
                                disabled: _vm.disableWithdrawal(payment.id)
                              }
                            },
                            [_vm._v(_vm._s(payment.label))]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "separator block my-6" }),
              _vm._v(" "),
              _c("sam-cart-contact-form", {
                attrs: { value: _vm.contact, errors: _vm.errors },
                on: { input: _vm.updateContactForm }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "separator block my-6" }),
              _vm._v(" "),
              _c("h2", { staticClass: "mt-0 mb-5" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Informations de facturation")))
              ]),
              _vm._v(" "),
              _c("address-input", {
                scopedSlots: _vm._u([
                  {
                    key: "manualAddress",
                    fn: function(ref) {
                      var data = ref.data
                      var updateCountry = ref.updateCountry
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "billingSettings.line1",
                              label: _vm.$t.__("common.labels.street_name")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { autocomplete: "off" },
                              model: {
                                value: data.line1,
                                callback: function($$v) {
                                  _vm.$set(data, "line1", $$v)
                                },
                                expression: "data.line1"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__(
                                "common.labels.more_address_informations"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { autocomplete: "off" },
                              model: {
                                value: data.line2,
                                callback: function($$v) {
                                  _vm.$set(data, "line2", $$v)
                                },
                                expression: "data.line2"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-row" },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "wp-3",
                                attrs: {
                                  prop: "billingSettings.postalCode",
                                  label: _vm.$t.__("common.labels.postal_code")
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { autocomplete: "off" },
                                  model: {
                                    value: data.postalCode,
                                    callback: function($$v) {
                                      _vm.$set(data, "postalCode", $$v)
                                    },
                                    expression: "data.postalCode"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "wp-7 ml-3",
                                attrs: {
                                  prop: "billingSettings.city",
                                  label: _vm.$t.__("common.labels.city")
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { autocomplete: "off" },
                                  model: {
                                    value: data.city,
                                    callback: function($$v) {
                                      _vm.$set(data, "city", $$v)
                                    },
                                    expression: "data.city"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-row" },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "wp-5",
                                attrs: {
                                  label: _vm.$t.__("common.labels.state")
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { autocomplete: "off" },
                                  model: {
                                    value: data.administrative,
                                    callback: function($$v) {
                                      _vm.$set(data, "administrative", $$v)
                                    },
                                    expression: "data.administrative"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "wp-5 ml-3",
                                attrs: {
                                  prop: "billingSettings.country",
                                  label: _vm.$t.__("common.labels.country")
                                }
                              },
                              [
                                _c("country-input", {
                                  attrs: {
                                    "default-value": {
                                      code: data.countryCode,
                                      name: data.country
                                    }
                                  },
                                  on: { change: updateCountry }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "algoliaWrapper",
                    fn: function(ref) {
                      var methods = ref.methods
                      var props = ref.props
                      var data = ref.data
                      return [
                        _c(
                          "el-form-item",
                          {
                            class: { hide: data.currentValue.manualMode },
                            attrs: {
                              prop: "billingSettings.line1",
                              label: _vm.$t.__("common.labels.street_name")
                            }
                          },
                          [
                            _c("algolia-input", {
                              attrs: {
                                "element-name": props.value._id,
                                "place-type": "address"
                              },
                              on: { "bubble-address": methods.captureAddress }
                            }),
                            _vm._v(" "),
                            _c("CompassLink", {
                              attrs: {
                                label: props.manuallyLabel,
                                type: "primary",
                                size: "medium"
                              },
                              on: { click: methods.switchMode }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.addressSettings,
                  callback: function($$v) {
                    _vm.addressSettings = $$v
                  },
                  expression: "addressSettings"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "wp-5",
                      attrs: {
                        prop: "billingLocale",
                        label: _vm.$t.__("common.labels.invoicing_language")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "wp-10",
                          model: {
                            value: _vm.contact.billingLocale,
                            callback: function($$v) {
                              _vm.$set(_vm.contact, "billingLocale", $$v)
                            },
                            expression: "contact.billingLocale"
                          }
                        },
                        _vm._l(_vm.billingLocales, function(locale) {
                          return _c("el-option", {
                            key: locale.code,
                            attrs: { label: locale.name, value: locale.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "wp-5 ml-4",
                      attrs: {
                        label: _vm.$t.__("common.labels.tax_number"),
                        prop: "vatIntra"
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.tvaIntra,
                          callback: function($$v) {
                            _vm.tvaIntra = $$v
                          },
                          expression: "tvaIntra"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "separator block my-6" }),
              _vm._v(" "),
              _c("h2", { staticClass: "mt-0 mb-5" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Personnalisation des emails")))
              ]),
              _vm._v(" "),
              _vm.contact.name
                ? _c("custom-message", { attrs: { context: "renew" } })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "resume" },
        [
          !_vm.renewOnOlderPricingVersion
            ? _c(
                "section",
                { staticClass: "pabsolute compare aright" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass:
                        "compare-btn warning-05-bkg warning-100 b-0 px-2 h-32",
                      on: {
                        click: function($event) {
                          _vm.activeCompare = !_vm.activeCompare
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "flex-row ai-center jc-center" },
                        [
                          _c("i", {
                            staticClass: "mr-1",
                            class: {
                              "icon-chevron-right": _vm.activeCompare,
                              "icon-chevron-left": !_vm.activeCompare
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "semibold" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Comparer")))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "xslide-fade" } },
                    [
                      _vm.activeCompare && !_vm.renewOnOlderPricingVersion
                        ? _c("compare-upsell-sheet", {
                            staticClass: "compare-sheet aleft",
                            attrs: { store: "renew" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "cart-summary",
            { attrs: { context: "renew", userSale: true } },
            [
              _c("template", { slot: "licences" }, [
                _c(
                  "ul",
                  { staticClass: "ov-auto mb-0 cart-recap-products" },
                  [
                    _vm._l(_vm.productsWithLicences, function(product, index) {
                      return _c(
                        "li",
                        {
                          key: product.code,
                          staticClass: "flex-row",
                          class: {
                            "mb-to-free-licences":
                              !_vm.freeLicencesByProduct(product.id) &&
                              _vm.previousFreeLicencesByProduct(product.id),
                            "mb-2":
                              index + 1 !== _vm.productsWithLicences.length
                          }
                        },
                        [
                          _c("div", [
                            _c("p", { staticClass: "grey m-0 fs-3" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$l10n.n__(
                                      "%(total)s licence %(productsName)s",
                                      "%(total)s licences %(productsName)s",
                                      _vm.products[product.id].quantity,
                                      {
                                        total:
                                          _vm.products[product.id].quantity,
                                        productsName: product.title
                                      }
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.freeLicencesByProduct(product.id)
                              ? _c("span", { staticClass: "grey" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$l10n.n__(
                                        "Dont %s offerte",
                                        "Dont %s offertes",
                                        _vm.freeLicencesByProduct(product.id),
                                        _vm.freeLicencesByProduct(product.id)
                                      )
                                    )
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.products[product.id].total
                            ? [
                                _vm.freeLicencesByProduct(product.id)
                                  ? _c(
                                      "p",
                                      { staticClass: "flex-item-right my-0" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "strike grey semibold"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f(
                                                  "numberformatWithOptions"
                                                )(
                                                  _vm._f("floatNumber")(
                                                    _vm.products[product.id]
                                                      .total.monthly
                                                      .total_amount
                                                  ),
                                                  _vm.numformat,
                                                  true
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "success-50 fs-3 pl-2 semibold"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f(
                                                  "numberformatWithOptions"
                                                )(
                                                  _vm._f("floatNumber")(
                                                    _vm.products[product.id]
                                                      .total.monthly
                                                      .total_amount_discounted
                                                  ),
                                                  _vm.numformat,
                                                  true
                                                )
                                              )
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "fs-2" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$l10n.__("/mois"))
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass:
                                          "flex-item-right my-0 fs-3 semibold grey"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm._f("numberformatWithOptions")(
                                                _vm._f("floatNumber")(
                                                  _vm.products[product.id].total
                                                    .monthly
                                                    .total_amount_discounted
                                                ),
                                                _vm.numformat,
                                                true
                                              )
                                            )
                                        ),
                                        _c("span", { staticClass: "fs-2" }, [
                                          _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                                        ])
                                      ]
                                    )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(
                      _vm.packsWithLicences.concat(
                        _vm.groupedPacksWithLicences
                      ),
                      function(product, index) {
                        return _c(
                          "li",
                          {
                            key: product.code,
                            staticClass: "flex-row",
                            class: {
                              "mb-2":
                                index + 1 !==
                                _vm.packsWithLicences.concat(
                                  _vm.groupedPacksWithLicences
                                ).length,
                              "mt-2": index === 0
                            }
                          },
                          [
                            _c("div", [
                              _c("p", { staticClass: "grey m-0 fs-3" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$l10n.__("Module %(productsName)s", {
                                        productsName: !!product.groups.length
                                          ? product.printableName
                                          : product.title
                                      })
                                    ) +
                                    "\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.products[product.id].total
                              ? [
                                  _vm.products[product.id].total.monthly
                                    .total_amount_discounted <
                                  _vm.products[product.id].total.monthly
                                    .total_amount
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "flex-item-right my-0 semibold"
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "strike grey semibold"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f(
                                                    "numberformatWithOptions"
                                                  )(
                                                    _vm._f("floatNumber")(
                                                      _vm.products[product.id]
                                                        .total.monthly
                                                        .total_amount
                                                    ),
                                                    _vm.numformat,
                                                    true
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "success-50 fs-3 pl-2"
                                            },
                                            [
                                              _vm.products[product.id].total
                                                .monthly
                                                .total_amount_discounted !== 0
                                                ? [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "numberformatWithOptions"
                                                          )(
                                                            _vm._f(
                                                              "floatNumber"
                                                            )(
                                                              _vm.products[
                                                                product.id
                                                              ].total.monthly
                                                                .total_amount_discounted
                                                            ),
                                                            _vm.numformat,
                                                            true
                                                          )
                                                        )
                                                    ),
                                                    _c(
                                                      "span",
                                                      { staticClass: "fs-2" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$l10n.__(
                                                              "/mois"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$l10n.__("Offert")
                                                      )
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    : _c(
                                        "p",
                                        {
                                          staticClass:
                                            "flex-item-right my-0 fs-3 semibold grey"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm._f(
                                                  "numberformatWithOptions"
                                                )(
                                                  _vm._f("floatNumber")(
                                                    _vm.products[product.id]
                                                      .total.monthly
                                                      .total_amount_discounted
                                                  ),
                                                  _vm.numformat,
                                                  true
                                                )
                                              )
                                          ),
                                          _c("span", { staticClass: "fs-2" }, [
                                            _vm._v(
                                              _vm._s(_vm.$l10n.__("/mois"))
                                            )
                                          ])
                                        ]
                                      )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }
                    )
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("template", { slot: "subtotal" }, [
                _c(
                  "div",
                  { staticClass: "flex-column fs-3 cart-recap-total-label" },
                  [
                    _c("span", { staticClass: "mb-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Total HT avant remise")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "mb-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Remise")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "mb-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Total HT")))
                    ]),
                    _vm._v(" "),
                    _vm.taxRate && _vm.taxRate !== 0
                      ? _c("span", { staticClass: "mb-2" }, [
                          _vm._v(
                            _vm._s(_vm.$l10n.__("TVA")) +
                              " " +
                              _vm._s(_vm.taxRate) +
                              "%"
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex-column aright fs-3" }, [
                  _c("span", { staticClass: "mb-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("numberformatWithOptions")(
                          _vm._f("floatNumber")(_vm.totalYearly.total_amount),
                          _vm.numformat,
                          true
                        )
                      )
                    ),
                    _c("span", { staticClass: "fs-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("/an")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mb-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("numberformatWithOptions")(
                          _vm._f("floatNumber")(
                            _vm.totalYearly.total_amount_discount
                          ),
                          _vm.numformat,
                          true
                        )
                      )
                    ),
                    _c("span", { staticClass: "fs-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("/an")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mb-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("numberformatWithOptions")(
                          _vm._f("floatNumber")(
                            _vm.totalYearly.total_amount_discounted
                          ),
                          _vm.numformat,
                          true
                        )
                      )
                    ),
                    _c("span", { staticClass: "fs-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("/an")))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.taxRate && _vm.taxRate !== 0
                    ? _c("span", { staticClass: "mb-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("numberformatWithOptions")(
                              _vm._f("floatNumber")(
                                _vm.totalYearly.total_amount_vat
                              ),
                              _vm.numformat,
                              true
                            )
                          )
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-column aright fs-3" }, [
                  _c("span", { staticClass: "mb-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("numberformatWithOptions")(
                          _vm._f("floatNumber")(_vm.totalMonthly.total_amount),
                          _vm.numformat,
                          true
                        )
                      )
                    ),
                    _c("span", { staticClass: "fs-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mb-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("numberformatWithOptions")(
                          _vm._f("floatNumber")(
                            _vm.totalMonthly.total_amount_discount
                          ),
                          _vm.numformat,
                          true
                        )
                      )
                    ),
                    _c("span", { staticClass: "fs-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mb-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("numberformatWithOptions")(
                          _vm._f("floatNumber")(
                            _vm.totalMonthly.total_amount_discounted
                          ),
                          _vm.numformat,
                          true
                        )
                      )
                    ),
                    _c("span", { staticClass: "fs-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.taxRate && _vm.taxRate !== 0
                    ? _c("span", { staticClass: "mb-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("numberformatWithOptions")(
                              _vm._f("floatNumber")(
                                _vm.totalMonthly.total_amount_vat
                              ),
                              _vm.numformat,
                              true
                            )
                          )
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("template", { slot: "total" }, [
                _c("div", { staticClass: "flex-row jc-space" }, [
                  _c(
                    "p",
                    { staticClass: "fs-4 my-0 bold cart-recap-total-label" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$l10n.__("Total TTC")) +
                          "\n                    "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "fs-4 my-0 aright bold" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm._f("numberformatWithOptions")(
                            _vm._f("floatNumber")(
                              _vm.totalYearly.total_amount_tax_included
                            ),
                            _vm.numformat,
                            true
                          )
                        )
                    ),
                    _c("span", { staticClass: "fs-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("/an")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "fs-4 my-0 aright bold" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm._f("numberformatWithOptions")(
                            _vm._f("floatNumber")(
                              _vm.totalMonthly.total_amount_tax_included
                            ),
                            _vm.numformat,
                            true
                          )
                        )
                    ),
                    _c("span", { staticClass: "fs-2" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.earlyRenewal
                  ? _c("div", { staticClass: "earlyRenewCedit mt-3" }, [
                      _c("span", { staticClass: "separator block mb-3" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "avoir flex-row jc-space" }, [
                        _c("p", { staticClass: "semibold fs-3 my-0 lh-20" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Avoir estimé")))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "semibold fs-3 my-0 lh-20" }, [
                          _vm._v(
                            "\n                            -\n                            " +
                              _vm._s(
                                _vm._f("numberformatWithOptions")(
                                  _vm._f("floatNumber")(_vm.earlyRenewCredit),
                                  _vm.numformat,
                                  true
                                )
                              ) +
                              "\n                        "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.isYearly
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "fs-12 gray-60 mb-0 mt-1 semibold lh-s"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "La prochaine échéance sera le %(nextPaymentDate)s à %(nextPaymentAmount)s",
                                      {
                                        nextPaymentDate:
                                          _vm.nextYearlyPaymentDate,
                                        nextPaymentAmount:
                                          _vm.nextYearlyPaymentAmount
                                      }
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isMonthly
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "fs-12 gray-60 mb-0 mt-1 semibold lh-s"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "La prochaine échéance sera le %(nextPaymentDate)s à %(nextPaymentAmount)s, puis les %(dueDates)s échéances suivantes à %(dueDateAmount)s",
                                      {
                                        nextPaymentDate:
                                          _vm.nextMonthlyPaymentDate,
                                        nextPaymentAmount:
                                          _vm.nextMonthlyPaymentAmount,
                                        dueDates: _vm.numberOfDueDates,
                                        dueDateAmount: _vm.dueDatesAmount
                                      }
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "template",
                { slot: "actions" },
                [
                  _c("CompassButton", {
                    staticClass: "wp-10 mt-4",
                    attrs: {
                      label: _vm.$t.__("common.actions.send_to_client"),
                      type: "primary",
                      loading: _vm.computeLoading
                    },
                    on: {
                      click: function($event) {
                        return _vm.submitForm("saleCartForm", "action")
                      }
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }